import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PulsesConstants } from '../store/pulses.constants'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { getPulsesSelector } from '../selectors/pulses.selector'

import { getServiceIdSelector } from '../../../../user/selectors'
import { IPulsesState } from '../store/pulses.types'

import { getPcrIdSelector } from '../../../../home/selectors'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../../../services/pcrDocs.service'
import { setResponse } from '../store/pulses.actions'

import { initialPulsesState } from '../store/pulses.reducer'

import { getSelectedDataFromObject } from '../../../../../utilities/data.util'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

export function* savePulses() {
  const pulses: IPulsesState = yield select(getPulsesSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pulsesObject = getSelectedDataFromObject(pulses, Object.keys(initialPulsesState))
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      prNabc: {
        ...pcrDoc.prNabc,
        ...pulsesObject,
      },
    }
    try {
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setResponse(response))
    } catch (e) {
      yield put(throwPcrException(`savePulses() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}
export function* savePulsesSaga() {
  yield takeLatest([PulsesConstants.SAVE_PULSES], performWithMutexHOG, savePulses)
}
